import { useContextState } from "../../hooks/theme"

const useStyles = ({ size }:{size?: 'small' | 'medium' | 'big'}) => {
    const { colors } = useContextState()
    let title = 16, description = 14, footer = 12

    if(size == 'small') {
        title = 14
        description = 12
        footer = 10
    }

    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
        },
        title: {
            fontSize: `${title}px`,
            color: colors.color13,
            fontWeight: '500'
        },
        description: {
            fontSize: `${description}px`,
            color: colors.color13,
            fontWeight: 'thin'
        },
        footer: {
            fontSize: `${footer}px`,
            color: colors.color13,
            fontWeight: 'thin'
        }
    }
}

export { useStyles }
